import { Zap, Sun, ShieldCheck, Recycle } from 'lucide-react';
import CategoryTemplate from '../components/CategoryTemplate';
import { getRelated } from '../data/serviceCatalog';

const LedLighting = () => {
  const trustPoints = [
    { Icon: Zap, label: '省エネ・低消費電力' },
    { Icon: Sun, label: '明るさ・色温度を選定' },
    { Icon: ShieldCheck, label: '屋内・屋外 対応' },
    { Icon: Recycle, label: '既存照明の入替対応' },
  ];

  // 実物写真を public/images/ 直下に配置します。
  const featuredProducts = [
    {
      name: 'ECOビームダイレクト（PRO）',
      subtitle: '看板用LED照明',
      description: '駐車料金看板、屋外看板、掲示板などに対応する看板用LED照明です。',
      image: '/images/eco-beam-series.png',
      file: '/images/catalogs/eco-beam-direct-pro.pdf',
    },
    {
      name: 'HSファクトリーライトシリーズ',
      subtitle: '工場・倉庫用高天井LED照明',
      description: 'UFO型のCOMPACT Kと角形のBRIX。設置環境に合わせて選べる2シリーズです。',
      image: '/images/factory-light-series.png',
      file: '/images/catalogs/hs-factory-light.pdf',
    },
  ];

  const process = [
    { title: 'ヒアリング', desc: '設置場所・希望の明るさ・用途・既存設備の状況をお伺いします。' },
    { title: '現地調査', desc: '天井高・器具寸法・配線状況・調光要件を確認します。' },
    { title: 'ご提案・見積提出', desc: '照度計算と器具構成のご提案、お見積りをご提出します。' },
    { title: '施工・引渡し', desc: '既存器具の撤去から新設・引渡しまで対応いたします。' },
  ];

  return (
    <CategoryTemplate
      id="led-lighting"
      eyebrow="LED LIGHT"
      name="LED照明"
      description="店舗・施設・屋外空間の照明を、明るさ・消費電力・配光まで含めてご提案します。既存照明のLED入替や施設全体の照明計画にも対応いたします。"
      tags={['省エネ', '長寿命', '屋内対応', '屋外対応', '既存入替対応']}
      heroImage="/images/services/led-lighting.png"
      trustPoints={trustPoints}
      featuredProducts={featuredProducts}
      showSamples={false}
      processSteps={process}
      relatedServices={getRelated(['signage', 'led-vision', 'custom-metal'])}
    />
  );
};

export default LedLighting;
